<template>
    <div class="box">
        <!-- <div class="dflexs head">
            <img class="returns" @click='returnBtn' src="../../assets/guild/returnimg.png" alt="">
            <div class="pagetitle">{{ $t('Withdrawal') }}</div>
        </div> -->
        <div class="text">
            <p>{{ $t('withdrawalInstructions.text1') }}</p>
            <p>{{ $t('withdrawalInstructions.text2') }}</p>
            <p>{{ $t('withdrawalInstructions.text3') }}</p>
            <p>{{ $t('withdrawalInstructions.text4') }}</p>
            <p @click="urlBtn" v-html="$t('withdrawalInstructions.text5')"></p>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: "App",
    components: {},
    data() {
        return {
            userInfo: [],
            token: null,
            uid: null,
            headers: null,
            langa: null,
        };
    },
    created() {
        this.$completes.complete("getUserInfo");
        window.getUserInfo = this.getUserInfo
        window['getUserInfo'] = (data) => {
            this.getUserInfo(data);
        }
    },
    mounted() {
    },
    methods: {
        getUserInfo(data) {
            this.userInfo = JSON.parse(data);
            this.uid = JSON.parse(data).userId
            this.langa = this.userInfo.lang
            let langs = this.userInfo.lang.substring(0, 2)
            let lang = this.userInfo.lang
            if (langs == 'zh') {
                if (lang == 'zh_TW' || lang == 'zh_HK') {
                    this.$i18n.locale = 'tc'
                }
                else {
                    this.$i18n.locale = 'zh'
                }
            }
            else if (langs == 'en') {
                this.$i18n.locale = 'en'
            }
            else if (langs == 'ar') {
                this.$i18n.locale = 'ar'
            }
            else if (langs == 'tr') {
                this.$i18n.locale = 'tr'
            }
            else if (langs == 'es') {
                this.$i18n.locale = 'es'
            }
            else {
                this.$i18n.locale = 'en'
            }
            document.title = this.$t('Withdrawal')
            document.querySelector('html').setAttribute('lang', this.$i18n.locale);
        },

      //线上地址:"https://help.pocketliveapp.com/#/?langType="
      //测试地址
        urlBtn() {
            if(axios.defaults.baseURL == 'https://gl.koudailive.com/'){
                window.location.href = "https://help.koudailive.com/#/?langType=" + this.langa + "&userId=" + this.uid + "&router=" + 2+ "&type=" + 1
            }else{
                window.location.href = "https://help.pocketliveapp.com/#/?langType=" + this.langa + "&userId=" + this.uid + "&router=" + 2+ "&type=" + 1
            }
        },
        returnBtn(){
           this.$completes.complete("getPreviousPage");
        }
    },
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
}

.box {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* html[lang="ar"] .head {
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
} */

html[lang="ar"] .text p {
    direction: rtl;
}

/* html[lang="ar"] .text p span{
    direction: rtl;
} */



/* .head {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.27rem;
    margin: 0 !important;
    left: 0;
    right: 0;
    z-index: 999;
    top: 0;
    padding-top: 44px;
} */

/* .returns {
    width: 0.4rem;
    height: 0.4rem;
} */

/* .pagetitle {
    font-size: 0.3rem;
    font-family: Mediums;
    color: #000000;
    flex: 1;
    text-align: center;
    padding-right: 0.4rem;
} */

.text {
    flex: 1;
    padding: 20px 18px;
}

.text p {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    margin-top: 20px;
}

.text p span {
    display: inline-block;
    color: #5dc48a;
}
</style>